import { Component, OnInit } from "@angular/core";
import { UserSearchService } from "../_services/user/user-search/user-search.service";
import { UnixToMomentDatePipe } from "../_helpers/pipes/unix-to-moment-date.pipe";
import { EditorGeographicArea } from "../_models/user/editorGeographicArea";
import { UserUtilites } from "../_models/user/user";
import { MatTableDataSource } from "@angular/material/table";

@Component({
    selector: "wfdss-gae-staff-report",
    templateUrl: "./gae-staff-report.component.html",
    styleUrls: ["./gae-staff-report.component.scss"],
    standalone: false
})
export class GaeStaffReportComponent implements OnInit {
  constructor(private userSearchService: UserSearchService) {}

  gaeStaffData: MatTableDataSource<EditorGeographicArea> =
  new MatTableDataSource<EditorGeographicArea>()

  gaeStaffTableColumnMetaData = [
    {
      columnName: "Name",
      propertyAccessor: (prop: EditorGeographicArea) => {
        return UserUtilites.getUserProfileFirstNameSpaceLastName(
          prop.userProfile
        );
      },
    },
    {
      columnName: "GA",
      propertyAccessor: (prop: EditorGeographicArea) => {
        return prop.geographicArea.shortName;
      },
    },
    {
      columnName: "Agency",
      propertyAccessor: (prop: EditorGeographicArea) => {
        return prop.jurisdictionalAgency.shortName;
      },
    },
    {
      columnName: "Primary Phone",
      propertyAccessor: (prop: EditorGeographicArea) => {
        return prop.userProfile?.phoneNumberPrimary;
      },
    },
    {
      columnName: "Primary Email",
      propertyAccessor: (prop: EditorGeographicArea) => {
        return prop.userProfile?.emailPrimary;
      },
    },
  ];

  sortingDataAccessor = (data: EditorGeographicArea, prop) => {
    switch (prop) {
      case "Name":
        return (
          UserUtilites.getUserProfileFirstNameSpaceLastName(data.userProfile) ??
          ""
        );
      case "GA": {
        console.log(data.geographicArea?.shortName ?? "")
        return data.geographicArea?.shortName ?? "";
      }
      case "Agency":
        return data.jurisdictionalAgency?.shortName ?? "";
      case "Primary Phone":
        return data.userProfile?.phoneNumberPrimary ?? "";
      case "Primary Email":
        return data.userProfile?.emailPrimary ?? "";
    }
  };

  ngOnInit(): void {
    this.userSearchService.getGaeStaffReport().subscribe((staff) => {
      this.gaeStaffData.data = staff;
    });
  }
}
